import { Module } from "vuex";

import { IRootState } from "@/store";
import { getters } from "@/store/modules/reportFile/getters";
import { actions } from "@/store/modules/reportFile/actions";
import { mutations } from "@/store/modules/reportFile/mutations";
import { IReportFileState, state } from "@/store/modules/reportFile/state";

export const reportFile: Module<IReportFileState, IRootState> = {
  actions,
  mutations,
  state,
  getters,
};
